<template>
  <div class="status-clazz-info">
    <PlatDataGridSite grid-id="PeClassInfo"
                      show-label></PlatDataGridSite>
  </div>
</template>

<script>
import PlatDataGridSite from '../../../wrapper/grid/PlatDataGridSite'
export default {
  name: 'StatusClazzInfo',
  components: {
    PlatDataGridSite
  }
}
</script>

<style lang="scss">
  .status-clazz-info {
    height: 100%;
  }
</style>
